export default {
  install(app) {
    app.config.globalProperties.$scrollTo = function (id, offset = 66) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        const yOffset = targetElement.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: yOffset, behavior: 'smooth' });
      }
    };
  }
};